import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"
import { useTheme } from "../../hooks/use-theme"
import { useIsMobile } from "../../hooks/use-mobile"

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme()
  const isMobile = useIsMobile()

  return (
    <Sonner
      theme={resolvedTheme === 'sepia' ? 'light' : resolvedTheme}
      className="toaster group"
      // Mobile: top-center (safe-area handled via CSS in styles.css, because
      // sonner's `offset` prop doesn't accept calc(env(...))).
      // Desktop: bottom-right corner.
      position={isMobile ? "top-center" : "bottom-right"}
      icons={{
        success: (
          <CircleCheckIcon className="size-4 text-[color:var(--aurora)]" />
        ),
        info: (
          <InfoIcon className="size-4 text-[#A8B8E8]" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4 text-[color:var(--ember)]" />
        ),
        error: (
          <OctagonXIcon className="size-4 text-destructive" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
